export class Login {
    constructor (
        public Email: string = '',
        public Password: string = ''
    ) { }
}
